<template>
    <div class="sideNav">
      <div class="sideNav__container">
        <div class="sideNav__menu">

          <div class="nav__menu--item">
            <div class="nav__logo">
              <router-link to="/dashboard" style="width:100%;">
                <span style="text-transform: none; font-size: 3.6rem;
    font-weight: 300;">J<em>u</em>mp</span>
              </router-link>
            </div>
            
          </div>

          
          <div class="nav__menu--item">
            <router-link :to="{name: 'users'}">
              search users <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'watchlistHome'}">
              watchlists <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'newUsers'}">
              new users <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'events'}">
              orders <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'shiftsTable'}">
              shifts <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>


          <div class="nav__menu--item">
            <router-link :to="{name: 'groups'}">
              Job groups <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'venues'}">
              Venues <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'supportHome'}">
              Support Tickets<i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'shiftLeads'}">
              Shift Lead Applications<i class="fas fa-chevron-right"></i>
            </router-link>
          </div>

          <div class="nav__menu--item">
            <router-link :to="{name: 'clients'}">
              Customers <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>

          <div class="nav__menu--item">
            <router-link :to="{name: 'contacts'}">
              Contacts <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          <div class="nav__menu--item">
            <router-link :to="{name: 'leadsHome'}">
              Marketing Leads <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
          

          <div class="nav__menu--item">
            <router-link :to="{name: 'team'}">
              company roster<i class="fas fa-chevron-right"></i>
            </router-link>
          </div>

          <div class="nav__menu--item">
            <router-link :to="{name: 'settingsHome'}">
              settings <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>

          <div class="nav__menu--item">
            <router-link :to="{name: 'reportsHome'}">
              reports <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
        
         
          <div class="nav__menu--item">
            <a @click="logout()">logout</a>
          </div>

        </div>

      </div>
      <div class="nav__menu--item">
            © Jump Staffing, 2023
          </div>
    </div>
</template>

<script>
// import SVG_TriangleLogo from '@/assets/svgs/SVG_TriangleLogo.vue'

export default {
  props: ['userProfile'],
  data: () => ({
    showSide: false,
    accDrop: false,
  }),
  computed: {
    pic () {
      return this.userProfile.photoUrl || 'https://firebasestorage.googleapis.com/v0/b/mvpes-25aef.appspot.com/o/avatar%20copy.png?alt=media&token=966c07c4-125a-490f-81be-4e2d26bf33fa'
    }
  },
  watch:{
    $route (to, from){
      this.showSide = false
    }
  },
  // components: {
  //   SVG_TriangleLogo
  // },
  methods: {
    logout() {
      this.$store.dispatch('logout')
    },
    showSideNav() {
      this.showSide = !this.showSide
    }
  }
}
</script>